module.exports = __webpack_public_path__ + "static/media/020.6ac16422.jpg";